if (!customElements.get("slideshow-component")) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super()
      this.selectors = {
        contents: ['.f-slideshow__content-wrapper'],
        selected: '.selected',
        flickity: 'flickity-component',
        pageDots: '.flickity-page-dots',
        pageCounter: '.flickity-page-counter'
      }
      this.domNodes = queryDomNodes(this.selectors, this)
      this.prevIndex = 0
      this.init()
    }
    
    disconnectedCallback() {
      clearInterval(this.check)
    }

    init() {
      this.check = setInterval(() => {
        this.slider = this.domNodes.flickity.slider && this.domNodes.flickity.slider.instance
        if (this.slider && typeof this.slider == 'object') {
          clearInterval(this.check)
          this.removeAttribute('data-media-loading')
          this.bindChange()
          if (this.domNodes.contents[0]) this.domNodes.contents[0].classList.add('selected')
          this.handleScreenChange()
          this.playVideo()
          if (this.domNodes.pageCounter) {
            this.domNodes.flickity.insertBefore(this.domNodes.pageCounter, null)
          }
        }
      }, 100)
    }

    /** Un solo handler di 'change' alla volta, altrimenti si accumulano a ogni refresh. */
    bindChange() {
      if (this.boundHandleChange) this.slider.off('change', this.boundHandleChange)
      this.boundHandleChange = this.handleChange.bind(this)
      this.slider.on('change', this.boundHandleChange)
    }

    /**
     * Ri-aggancia il componente dopo che le slide sono cambiate nel DOM
     * (le double slide passano da 1 cella su desktop a 2 su mobile).
     * Niente data-media-loading qui: e' lo skeleton del primo caricamento e
     * dipinge un pannello opaco (base.css [data-media-loading]:after), che
     * resterebbe visibile sopra slide gia' a schermo.
     */
    refresh() {
      clearInterval(this.check)
      this.querySelectorAll('.f-slideshow__content-wrapper').forEach(item => {
        item.classList.remove('selected', 'f-slideshow__content--out')
      })
      this.domNodes = queryDomNodes(this.selectors, this)
      this.prevIndex = 0

      const instance = this.domNodes.flickity.slider && this.domNodes.flickity.slider.instance
      if (!instance) {
        this.init()
        return
      }

      this.slider = instance
      this.bindChange()

      const index = Math.max(0, Math.min(this.slider.selectedIndex || 0, this.domNodes.contents.length - 1))
      if (this.domNodes.contents[index]) this.domNodes.contents[index].classList.add('selected')
      this.prevIndex = index
      if (this.domNodes.pageCounter) {
        this.domNodes.flickity.insertBefore(this.domNodes.pageCounter, null)
      }
      this.playVideo()
    }

    handleChange(index) {
      const sliderCounterCurrent = this.querySelector('.flickity-counter--current')
      const slideContentCurrent = this.domNodes.contents[index];
      if (!slideContentCurrent) return
      const currentTextColor = slideContentCurrent.dataset.textColor;
      this.style.setProperty('--slider-controls-color', currentTextColor);

      const previousContent = this.domNodes.contents[this.prevIndex]
      this.domNodes.contents.forEach(item => item.classList.remove('selected'))
      if (previousContent) previousContent.classList.add('f-slideshow__content--out')
      slideContentCurrent.classList.add('selected')
      setTimeout(() => {
        if (previousContent) previousContent.classList.remove('f-slideshow__content--out')
        this.prevIndex = index
      }, 300)

      // Handle page counter
      if (this.domNodes.pageCounter && sliderCounterCurrent) {
        sliderCounterCurrent.textContent = index + 1
      }
      
      this.playVideo()
    }
    
    playVideo() {
      this.pauseAllMedia();
      const selectedElm = this.slider.selectedElement;
      if (!selectedElm) return;
    
      const deferredMediaItems = Array.from(
        selectedElm.querySelectorAll("deferred-media")
      );
    
      const deferredMedia =
        deferredMediaItems.find((item) => {
          return window.getComputedStyle(item).display !== "none";
        }) || deferredMediaItems[0];
    
      if (deferredMedia) {
        deferredMedia.loadContent();
        const youtube = deferredMedia.querySelector(".js-youtube");
        const vimeo = deferredMedia.querySelector(".js-vimeo");
        const video = deferredMedia.querySelector("video");
    
        if (video) video.play();
        if (youtube) {
          youtube.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        }
        if (vimeo) {
          vimeo.contentWindow.postMessage('{"method":"play"}', "*");
        }
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }

    handleScreenChange() {
      if (FoxThemeSettings.isMobile) {
        // this.domNodes.flickity.toggleFade()
      }
      document.addEventListener('matchMobile', () => {
        // this.domNodes.flickity.toggleFade()
      })
      document.addEventListener('unmatchMobile', () => {
        // this.domNodes.flickity.toggleFade(true)
      })
    }
  }

  customElements.define('slideshow-component', SlideshowComponent)
}